// ?use_ios_ui — the close confirmation names what confirming does (iOS
// closeAlertTitle / closeAlertMessage). A web page has no App Clip to end,
// so the two Android cases are: back to the storefront, or the session ends.

export function closeConfirmCopy({ hasReturnURL }: { hasReturnURL: boolean }): {
  title: string
  message: string
} {
  return {
    title: 'Close AR view?',
    message: hasReturnURL
      ? 'This ends your AR session and takes you back to the website.'
      : "This ends your AR session. Your placed wheels won't be kept.",
  }
}
